// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-image {
  color: #009900;
}

.file-video {
  color: #0000aa;
}

.file-audio {
  color: #000066;
}

.file-csv {
  color: #aaa;
}

.file-alt {
  color: #aaa;
}

.file-archive {
  color: #ec9706;
}

.file-pdf {
  color: #aa0000;
}

.file-powerpoint {
  color: #ee0000;
}

.file-word {
  color: #203e81;
}

.file-excel {
  color: #1d5b2d;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
